export default class InitializeCharactersEvent {
    constructor(type) {
        this._type = type;
    }

    get type() {
        return this._type;
    }
}

InitializeCharactersEvent.PERFORM = "InitializeCharactersEvent.PERFORM";